export default {"cls1":"logo-module__cls1__Go-q4","cls2":"logo-module__cls2__YAWbD","st0":"logo-module__st0__CMO-a","st1":"logo-module__st1__SQMUN"};